import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { User } from 'src/app/shared/models';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToolbarComponent extends DestructorComponent implements OnInit {
  breadcrumbs: Array<{ label: string, url: string }> = [];
  actionLinks: Array<{ title: string, url: string }> = [];
  pageTitle: string = '';
  navTitle: string = '';
  user: User | null = null;
  constructor(private router: Router, private route: ActivatedRoute,private _globalStateService:GlobalStateService) { 
    super();
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
        this.updateActionLinks();
      });

    this.updateBreadcrumbs();
    this.updateActionLinks();
  }

  private updateBreadcrumbs() {
    const breadcrumbs: any[] = [];
    let currentRoute = this.route.root;
    let url = '';

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      const routeSnapshot = currentRoute.snapshot;
      const routeURL = routeSnapshot.url.map(segment => segment.path).join('/');

      if (routeURL) {
        url += `/${routeURL}`;
      }

      const navTitle = routeSnapshot.data['navTitle'];
      if (navTitle) {
        breadcrumbs.push({ label: navTitle, url });
      }

      if (routeSnapshot.data['pageTitle']) {
        this.pageTitle = routeSnapshot.data['pageTitle'];
      }
     
      if (routeSnapshot.data['navTitle']) {
        this.navTitle = routeSnapshot.data['navTitle'];
      }

    }

    this.breadcrumbs = breadcrumbs;
  }

  private updateActionLinks() {
    const targetRoute = this.findTargetRoute(this.route.root);
    const basePath = this.router.url.split('/').slice(0, 3).join('/'); // Dynamic basePath

    if (targetRoute?.routeConfig?.children) {
      let routeActionLinks = targetRoute.routeConfig.children
        .filter(child => child.data?.['showInActions'])
        .map(child => ({
          title: child.data?.['navTitle'] || child.data?.['title'],
          url: `${basePath}/${child.path}`,
          path: child.path
        }));
      
      this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;
        if(this.user?.role_complete.is_admin){
            this.actionLinks = routeActionLinks;
        }
        else{
          this.actionLinks = routeActionLinks.filter((child:any) => {
              return this.user?.role_complete.permissions[child.path]?.view;
          });
        }
      })
    )

      


    } else {
      this.actionLinks = [];
    }



  }

  private findTargetRoute(route: ActivatedRoute): ActivatedRoute | null {
    if (route.routeConfig?.data?.['hasActions']) return route;

    for (const child of route.children) {
      const result = this.findTargetRoute(child);
      if (result) return result;
    }

    return null;
  }
}
